import { RouteObject } from 'react-router';
import { NotFoundPage } from './pages';

export const notFoundRoutes: RouteObject[] = [{ path: '*', Component: NotFoundPage }];
